import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Res, UserInfo } from 'src/app/models';
import { LanguageService, ApiUsersService, ValidatorsService, DatetimeService, NotificationService, DialogModalService, FilesService } from 'src/app/services';
import { UserEditValidator } from './user-edit.validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadProcessComponent } from 'src/app/components/dialog';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  user: UserInfo;
  userId: string = '';
  errorMessages: any;
  multiple: boolean = false;
  editProfile: boolean;
  avatar: any;

  userForm: UntypedFormGroup = this.fb.group({
    first_name: [null, this.validator.first_name],
    last_name: [null, this.validator.last_name],
    second_name: [null, this.validator.second_name],
    date_of_birth: [null, this.validator.date_of_birth],
    login: [{ value: null, disabled: true }, this.validator.login],
    email: [null, this.validator.email],
    phone: [null, this.validator.phone],
    avatar_pic: [null]
  });

  passwordForm: UntypedFormGroup = this.fb.group({
    old_password: [null, this.validator.password],
    password: [null, this.validator.password],
    confirm_password: [null, this.validator.password],
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiUsers: ApiUsersService,
    private datetimeService: DatetimeService,
    private currentRoute: ActivatedRoute,
    private validator: UserEditValidator,
    private validatorService: ValidatorsService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.userId = this.currentRoute.snapshot.paramMap.get('id');
    this.errorMessages = this.validator.errorMessages;

    if (this.userId) {

      this.onEdit();
    }
    else {

      this.user = this.apiUsers.userInfo;

      if (this.user) {

        this.setDataInForm();
      }

      this.subscriptions.add(
        this.apiUsers.listenerUserInfo().subscribe((value: UserInfo) => {

          this.user = value;
          this.setDataInForm();
        })
      );
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUsers.edit(this.userId).subscribe((response: Res) => {
        console.log('[RESPONSE] user edit: ', response);

        if (response) {

          this.user = { ...response.result };
          this.setDataInForm();

          this.progressRef.complete();
        }
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   */
  setDataInForm(): void {

    let dateOfBirth = null;

    if (this.user.date_of_birth) {

      dateOfBirth = this.datetimeService.convertDateForDatepicker(this.user.date_of_birth);
    }

    if (this.user.avatar_pic) {

      this.getImageContent(this.user.avatar_pic);
    }

    this.userForm.setValue({
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      second_name: this.user.second_name,
      date_of_birth: dateOfBirth,
      login: this.user.login,
      email: this.user.email,
      phone: this.user.phone,
      avatar_pic: this.user.avatar_pic
    });

    this.passwordForm.setValue({
      old_password: null,
      password: null,
      confirm_password: null,
    });
  }

  /** UPLOAD FILES VER №1 */
  /**
   *
   * @param file
   */
  uploadFileDialogWindow(file: any): any {

    let data = {
      files: file,
      option: {
        multiple: this.multiple,
        component: 'user'
      }
    }

    this.dialogModal.open(data, FileUploadProcessComponent).then(
      (response) => {

        if (response.result) {
          console.log("RESULT: ", response);

          this.getImageContent(response.result.id);
          this.userForm.get('avatar_pic').setValue(response.result.id);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param product Product
   */
  getImageContent(file_id: any): void {

    this.subscriptions.add(
      this.fileService.getImageContent(file_id).subscribe((response: any) => {

        if (response != null) {

          this.avatar = response.result;
        }
      })
    );
  }

  onUpdatePassword() {

    let form = this.passwordForm.value;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUsers.userPassworUpdate(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          if (!this.userId) {

            // this.apiUsers.setUserInfo(response.result);
            this.notification.show('success', 'Данные успешно сохранены!');
            setTimeout(() => window.location.reload(), 1000);
          }

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
          setTimeout(() => window.location.reload(), 1000);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  onUpdate() {

    let form = this.userForm.value;
    let dateOfBirth: string = '';

    if (form.date_of_birth) {

      let month = form.date_of_birth.month < 10 ? '0' + form.date_of_birth.month : form.date_of_birth.month;
      dateOfBirth = form.date_of_birth.year + '-' + month + '-' + form.date_of_birth.day;
    }

    let data = {
      id: this.user.id,
      first_name: form.first_name,
      last_name: form.last_name,
      second_name: form.second_name,
      date_of_birth: dateOfBirth,
      email: form.email,
      phone: form.phone,
      avatar_pic: form.avatar_pic
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUsers.update(data).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          if (!this.userId) {

            this.apiUsers.setUserInfo(response.result);
          }

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
          setTimeout(() => window.location.reload(), 1000);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.userForm.get(field), type);
  }

  /**
   * 
   * @param field 
   * @param type 
   */
   validationPassword(field: string, type: string): boolean {

    return this.validatorService.validation(this.passwordForm.get(field), type);
  }



  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.userForm.get(field));
  }
}
